import React from 'react';
export function WhatIsIncluded() {
  const items = [{
    title: 'Plumcake Classici',
    desc: 'Ricette tradizionali che funzionano sempre',
    color: 'blue'
  }, {
    title: 'Plumcake Marmorizzati',
    desc: 'Combinazioni perfette di sapori',
    color: 'green'
  }, {
    title: 'Plumcake alla Frutta',
    desc: 'Freschi e pieni di gusto naturale',
    color: 'orange'
  }, {
    title: 'Plumcake Speziati',
    desc: 'Sapori unici e irresistibili',
    color: 'purple'
  }, {
    title: 'Plumcake per Ogni Occasione',
    desc: 'Colazione, merenda, dessert e regali',
    color: 'red'
  }];
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return 'bg-blue-50 border-blue-200 text-blue-900';
      case 'green':
        return 'bg-green-50 border-green-200 text-green-900';
      case 'orange':
        return 'bg-orange-50 border-orange-200 text-orange-900';
      case 'purple':
        return 'bg-purple-50 border-purple-200 text-purple-900';
      case 'red':
        return 'bg-red-50 border-red-200 text-red-900';
      default:
        return 'bg-gray-50 border-gray-200 text-gray-900';
    }
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-338">
      <div className="max-w-3xl mx-auto" data-id="element-339">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-340">
          📦 Dentro questo libro scoprirai:
        </h2>

        <div className="space-y-4" data-id="element-341">
          {items.map((item, index) => <div key={index} className={`flex items-center gap-4 p-5 rounded-2xl border ${getColorClasses(item.color)} transition-transform hover:-translate-y-1`} data-id="element-342">
              <div className="w-12 h-12 rounded-full bg-white/60 flex items-center justify-center font-bold text-xl flex-shrink-0 shadow-sm" data-id="element-343">
                {index + 1}
              </div>
              <div data-id="element-344">
                <h3 className="font-bold text-lg" data-id="element-345">{item.title}</h3>
                <p className="opacity-80 mt-1" data-id="element-346">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}